<button
  type="button"
  aria-label="Udostępnij artykuł"
  class="flex gap-1 items-center hover:opacity-50"
>
  <ng-content></ng-content>
  <span class="text-xs font-semibold hidden sm:inline-block" *ngIf="value">
    {{ value }}
  </span>
</button>
